import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import AppUrl from '../../restApi/AppUrl';
import IRestClient from '../../restApi/IRestClient';
import ReactHtmlParser from 'react-html-parser';
import Wentwrong from '../Wentwrong/Wentwrong';
import { FaArrowRight, FaHandHoldingHeart, FaChevronDown } from 'react-icons/fa';
import { motion } from 'framer-motion';
import SectionHeader from '../SectionHeader/SectionHeader';

class RecentProjects extends Component {
  constructor() {
    super();
    this.state = {
      myData: [],
      error: false,
      loading: true,
      visibleProjects: 6
    };
  }

  componentDidMount() {
    IRestClient.GetRequest(AppUrl.Recentprojectshome).then(result => {
      if (result == null) {
        this.setState({ error: true, loading: false });
      } else {
        this.setState({ myData: result, loading: false });
      }
    }).catch(error => {
      this.setState({ error: true });
    });
  }

  loadMore = () => {
    this.setState(prevState => ({
      visibleProjects: prevState.visibleProjects + 3
    }));
  };

  getProjectStyle = (projectTitle, index) => {
    if (!projectTitle || typeof projectTitle !== 'string') {
      return { borderColor: 'rgb(147 197 253)', badgeColor: 'rgb(34 197 94)' };
    }
    const title = projectTitle.toLowerCase();
    if (title.includes('fundraiser') || title.includes('donation'))
      return { borderColor: 'rgb(34 197 94)', badgeColor: 'rgb(34 197 94)' };
    if (title.includes('volunteer') || title.includes('help'))
      return { borderColor: 'rgb(147 197 253)', badgeColor: 'rgb(59 130 246)' };
    if (title.includes('awareness') || title.includes('education'))
      return { borderColor: 'rgb(34 197 94)', badgeColor: 'rgb(34 197 94)' };
    if (title.includes('celebration') || title.includes('success'))
      return { borderColor: 'rgb(251 146 60)', badgeColor: 'rgb(251 146 60)' };
    return { borderColor: 'rgb(147 197 253)', badgeColor: 'rgb(59 130 246)' };
  };

  render() {
    const { myData, loading, error, visibleProjects } = this.state;

    if (error) return <Wentwrong />;

    if (loading) {
      return (
        <section className="py-20 bg-neutral-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <div className="animate-pulse bg-gray-200 rounded-full h-7 w-36 mx-auto mb-4" />
              <div className="animate-pulse bg-gray-200 rounded-xl h-12 w-72 mx-auto mb-4" />
              <div className="animate-pulse bg-gray-200 rounded h-4 w-80 mx-auto" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[1, 2, 3].map(i => (
                <div key={i} className="bg-white rounded-2xl shadow-lg overflow-hidden">
                  <div className="animate-pulse bg-gray-200 w-full" style={{ aspectRatio: '3/2' }} />
                  <div className="p-6">
                    <div className="animate-pulse bg-gray-200 rounded h-6 w-3/4 mb-3" />
                    <div className="animate-pulse bg-gray-200 rounded h-4 w-full mb-2" />
                    <div className="animate-pulse bg-gray-200 rounded h-4 w-5/6 mb-5" />
                    <div className="animate-pulse bg-gray-200 rounded-lg h-10 w-32" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      );
    }

    const displayedProjects = myData.slice(0, visibleProjects);
    const hasMore = visibleProjects < myData.length;

    return (
      <section className="py-20 bg-neutral-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* Section Header */}
          <SectionHeader
            badge="Our Impact"
            title="Recent Projects"
            subtitle="Discover how our work is transforming lives and communities through impactful humanitarian initiatives."
            variant="light"
            align="center"
            className="mb-12"
          />

          {/* Projects Grid */}
          {displayedProjects && displayedProjects.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
              {displayedProjects.map((project, index) => {
                if (!project) return null;
                const projectTitle = project.project_title || 'Untitled Project';
                const projectDescription = project.project_description || 'No description available';
                const projectImage = project.project_image || '/default-project-image.jpg';
                const projectId = project.id || index;

                return (
                  <motion.div
                    key={projectId}
                    className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-neutral-100 flex flex-col"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    whileHover={{ y: -10 }}
                  >
                    {/* Hover overlay — brand gradient, mirrors allprojects ::before effect */}
                    <div
                      className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                      style={{ background: 'linear-gradient(135deg, rgba(27,43,92,0.08) 0%, rgba(46,139,84,0.05) 100%)', zIndex: 0 }}
                    />

                    {/* Image */}
                    <div className="relative overflow-hidden z-10" style={{ aspectRatio: '3/2' }}>
                      <img
                        src={projectImage}
                        alt={projectTitle}
                        loading="lazy"
                        decoding="async"
                        onError={e => { e.currentTarget.src = '/default-project-image.jpg'; }}
                        className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-40" />
                    </div>

                    {/* Content */}
                    <div className="p-6 flex flex-col flex-1 relative z-10">
                      <h3 className="text-lg font-bold text-primary-900 mb-2 line-clamp-2 group-hover:text-secondary-700 transition-colors duration-300">
                        <Link to={`/projectdetails/${projectId}/${projectTitle}`} className="hover:text-secondary-700 transition-colors duration-300">
                          {projectTitle}
                        </Link>
                      </h3>

                      <p className="text-sm text-neutral-500 mb-5 leading-relaxed">
                        {ReactHtmlParser(projectDescription.substring(0, 120))}
                        {projectDescription.length > 120 && '...'}
                      </p>

                      <Link
                        to={`/projectdetails/${projectId}/${projectTitle}`}
                        className="inline-flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-white font-semibold py-2.5 px-5 rounded-xl transition-all duration-300 text-sm shadow-md hover:shadow-lg group mt-auto"
                      >
                        <span>View Project</span>
                        <FaArrowRight className="text-xs transition-transform duration-300 group-hover:translate-x-1" />
                      </Link>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="inline-flex flex-col items-center gap-4 bg-white rounded-3xl p-12 max-w-sm mx-auto shadow-lg">
                <FaHandHoldingHeart className="text-5xl text-neutral-300" />
                <h3 className="text-xl font-bold text-neutral-700">No Projects Available</h3>
                <p className="text-neutral-500 text-sm text-center">
                  Check back later for our latest humanitarian initiatives.
                </p>
              </div>
            </div>
          )}

          {/* Load More + View All */}
          <div className="text-center flex flex-col sm:flex-row items-center justify-center gap-4">
            {hasMore && (
              <motion.button
                onClick={this.loadMore}
                className="inline-flex items-center gap-2 bg-white hover:bg-neutral-100 text-primary-800 font-semibold py-3 px-8 rounded-xl border-2 border-primary-200 hover:border-primary-400 transition-all duration-300 shadow-sm hover:shadow-md"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <span>Load More</span>
                <FaChevronDown className="text-sm" />
              </motion.button>
            )}
            <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
              <Link
                to="/allprojects"
                className="inline-flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-8 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg"
              >
                <span>View All Projects</span>
                <FaArrowRight className="text-sm" />
              </Link>
            </motion.div>
          </div>
        </div>
      </section>
    );
  }
}

export default RecentProjects;
